const prefix = '@notifications';

export const NotificationsActionType = {
  GetNotifications: `${prefix}/NOTIFICATIONS_QUERY`,
  GetNotificationsCount: `${prefix}/NOTIFICATIONS_COUNT_QUERY`,
  ReadAllNotifications: `${prefix}/READ_ALL_NOTIFICATIONS_MUTATION`,
  ReadNotification: `${prefix}/READ_NOTIFICATION_MUTATION`,
  SubscribeDeviceMutation: `${prefix}/SUBSCRIBE_DEVICE_MUTATION`,
};
